import CaseBlockTitle from "../../common/case-block-title/case-block-title";
import CasesFeaturedBulletItem from "./cases-featured-bullet-item";
import "./cases-featured-bullets-block.sass";

type Props = {
  heading: string;
  featuredBullets: {
    id: string | number;
    bulletText: string;
    bulletTitle: string;
    description: string;
    image: {
      url: string;
    };
  }[];
};

const CasesFeaturedBulletsBlock = ({ heading, featuredBullets }: Props) => {
  return (
    <div className="cases-featured-bullets-block">
      <CaseBlockTitle>{heading}</CaseBlockTitle>

      {featuredBullets.map((bullet) => (
        <CasesFeaturedBulletItem
          key={bullet.id}
          bulletText={bullet.bulletText}
          bulletTitle={bullet.bulletTitle}
          description={bullet.description}
          image={bullet.image}
        />
      ))}
    </div>
  );
};

export default CasesFeaturedBulletsBlock;
